import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FaviconService {

  constructor() { }

  setFaviconByUrl(url: string) {
    let linkMain: HTMLLinkElement | null = document.querySelector("link[rel*='icon']");
    let linkAppleTouchIcon: HTMLLinkElement | null = document.querySelector("link[rel*='apple-touch-icon']");
    let linkIcon32: HTMLLinkElement | null = document.querySelector("link[rel*='icon'][type*='image/png'][sizes*='32x32']");
    let linkIcon16: HTMLLinkElement | null = document.querySelector("link[rel*='icon'][type*='image/png'][sizes*='16x16']");
    let linkManifest: HTMLLinkElement | null = document.querySelector("link[rel*='manifest']");
    let linkMaskIcon: HTMLLinkElement | null = document.querySelector("link[rel*='mask-icon']");

    let faviconFolderPath = "/assets/img/favicon/";

    if(url.startsWith("/klasse")) {
      faviconFolderPath = "/assets/img/favicon-klasse/";
    } else if(url.startsWith("/rookieday")) {
      faviconFolderPath = "/assets/img/favicon-rookieday/";
    } else if(url.startsWith("/rookie")) {
      faviconFolderPath = "/assets/img/favicon-rookie/";
    }

    if(linkMain) {
      linkMain.href = faviconFolderPath + "favicon.ico";
    }

    if(linkAppleTouchIcon) {
      linkAppleTouchIcon.href = faviconFolderPath + "apple-touch-icon.png";
    }

    if(linkIcon32) {
      linkIcon32.href = faviconFolderPath + "favicon-32x32.png";
    }

    if(linkIcon16) {
      linkIcon16.href = faviconFolderPath + "favicon-16x16.png";
    }

    if(linkManifest) {
      linkManifest.href = faviconFolderPath + "site.webmanifest";
    }

    if(linkMaskIcon) {
      linkMaskIcon.href = faviconFolderPath + "safari-pinned-tab.svg";
    }
  }
}
